/* ux-slideout-rescate.js — UnionX 01/09/2026
   Rescata la tienda del estado en que queda MUERTA: <body> con una clase `slideout-*--open`
   (que en stylesheet.css fuerza overflow:hidden) pero SIN ningun cajon en pantalla. Ahi no se
   scrollea, el velo gris tapa todo, las X quedan fuera del viewport y ni Escape ni tocar el velo
   salvan: `closeActiveSlideout` desreferencia `.slideout--active` y revienta con TypeError.
   La unica salida que le queda al cliente es recargar.

   Como se llega: `.js-mini-cart-trigger` tiene DOS listeners. Uno abre el cajon al toque; el otro
   (ajaxCart.init) hace getCart().then(-> showDrawer()) y REABRE el cajon cuando vuelve el fetch de
   /cart.js (~390 ms medidos), sin mirar si el cliente ya lo cerro. Si en esa ventana el cliente
   abre el menu, quedan dos cajones abiertos, y close() solo quita la clase de UNO mientras borra
   `.slideout--active` de TODOS.

   Esto NO arregla la carrera —vive en theme.js, minificado, y se perderia al actualizar el tema—:
   detecta el estado imposible y lo deshace. Aditivo y reversible: borrar el archivo y su linea en
   theme.liquid. */
(function () {
  "use strict";
  function clasesAbiertas() {
    var out = [], cs = document.body.classList;
    for (var i = 0; i < cs.length; i++) { if (/^slideout-.*--open$/.test(cs[i])) out.push(cs[i]); }
    return out;
  }
  function activosVisibles() {
    var out = [], ns = document.querySelectorAll(".slideout--active");
    for (var i = 0; i < ns.length; i++) {
      var r = ns[i].getBoundingClientRect();
      if (r.width > 50 && r.right > 0 && r.left < window.innerWidth) out.push(ns[i]);
    }
    return out;
  }
  function muerta() { return clasesAbiertas().length > 0 && activosVisibles().length === 0; }
  function limpiar() {
    var abiertas = clasesAbiertas();
    for (var i = 0; i < abiertas.length; i++) document.body.classList.remove(abiertas[i]);
    var ns = document.querySelectorAll(".slideout--active");
    for (var j = 0; j < ns.length; j++) ns[j].classList.remove("slideout--active");
  }

  /* ---------- CAUSA: el mini-carro se reabre solo despues de que el cliente lo cerro ----------
     `.js-mini-cart-trigger` tiene DOS listeners: uno abre el cajon al toque, y otro
     (ajaxCart.init) hace getCart().then(-> showDrawer()). Ese `.then()` llega cuando vuelve
     /cart.js y abre el cajon SIN mirar si el cliente ya lo cerro.
     Medido en vivo el 01/09/2026, cerrando con la X a distintos tiempos despues de abrir:
        80 ms -> se reabre | 200 ms -> se reabre | 400 ms -> ya no | 1200 ms -> ya no.
     Se envuelve showDrawer para que no abra si el ultimo gesto del cliente fue CERRAR. Cualquier
     otro click cuenta como intencion de abrir (agregar al carro, quickview, el propio trigger),
     asi que el flujo normal no se toca. */
  var tCierre = 0, tApertura = 0;
  document.addEventListener("click", function (e) {
    var t = e.target;
    var cierra = t && t.closest && t.closest(".js-slideout-close, .js-slideout-overlay");
    if (cierra) tCierre = Date.now(); else tApertura = Date.now();
  }, true);

  function envolverShowDrawer() {
    var ac = window.Shopify && Shopify.theme && Shopify.theme.ajaxCart;
    if (!ac || ac.__uxNoReabrir) return !!(ac && ac.__uxNoReabrir);
    if (typeof ac.showDrawer !== "function") return false;
    var orig = ac.showDrawer;
    ac.showDrawer = function () {
      if (tCierre > tApertura && Date.now() - tCierre < 2000) return;
      return orig.apply(this, arguments);
    };
    ac.__uxNoReabrir = true;
    return true;
  }
  if (!envolverShowDrawer()) {
    var intentos = 0;
    var reintento = setInterval(function () {
      if (envolverShowDrawer() || ++intentos > 40) clearInterval(reintento);
    }, 250);
  }

  /* Vigilante. Exige DOS pasadas seguidas (1,4 s) para no cortar una apertura en curso: la clase
     del body se pone antes de que el cajon termine de entrar, y ahi todavia mide casi nada. */
  var fallas = 0;
  setInterval(function () {
    if (!muerta()) { fallas = 0; return; }
    if (++fallas < 2) return;
    fallas = 0;
    limpiar();
  }, 700);
  /* Salidas inmediatas, para no hacerlo esperar 1,4 s: el velo y Escape. Ambas en captura, y solo
     actuan si NO hay cajon a la vista, asi que no le pisan el comportamiento normal al tema. */
  document.addEventListener("click", function (e) {
    var t = e.target;
    if (!t || !t.classList || !t.classList.contains("js-slideout-overlay")) return;
    if (activosVisibles().length === 0 && clasesAbiertas().length > 0) limpiar();
  }, true);
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    if (muerta()) limpiar();
  }, true);
})();
